<template>
    <modal :allowCancel="false" custom-class="max-w-sm" @closed="closeModal()">
        <div class="shift-delivery-modal" >
            <div class="shift-delivery-content" v-if="shiftWeek && !success">
                <p v-text="$t('SHIFT_DELIVERY_WEEK', { plan: getFrequencyWithoutBraces })"></p>
                <p><strong>{{newDeliveryDateFormatted}}</strong></p>
                <button
                    type="button"
                    class="btn btn--primary btn--half"
                    @click="savePlan()"
                    v-text="$t('SHIFT_DELIVERY_CONFIRM')">
                </button>
                <button
                    type="button"
                    class="btn btn--secondary btn--half"
                    @click="closeModal()"
                    v-text="$t('SHIFT_DELIVERY_CANCEL')">
                </button>
            </div>
            <div class="shift-delivery-content" v-if="shiftFrequency && !success">
                <p v-html="$t('SHIFT_DELIVERY_PLAN', { plan: offeredPlan.name })"></p>
                <p v-html="$t('SHIFT_DELIVERY_PLAN_START_DATE', { plan: offeredPlan.name })"></p>
                <div class="dropdown">
                    <Dropdown
                        v-model="selectedNextDelivery"
                        :inputStyle="'border-color: black;'"
                        :track-by="'human'"
                        :label="'human'"
                        :placeholder="'Choose a delivery date'"
                        :items="allowedDeliveries" />
                </div>
                <button
                    type="button"
                    class="btn btn--primary btn--half"
                    @click="savePlan()"
                    v-text="$t('SHIFT_DELIVERY_SAVE')">
                </button>
                <button
                    type="button"
                    class="btn btn--secondary btn--half"
                    @click="showCustomerServiceMessage()"
                    v-text="$t('SHIFT_DELIVERY_PLAN_CANCEL')">
                </button>
            </div>
            <div class="shift-delivery-content" v-if="success">
                <p v-html="success"></p>
                <button
                    type="button"
                    class="btn btn--secondary btn--half"
                    @click="closeModal()"
                    v-text="$t('SHIFT_DELIVERY_CLOSE')">
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Dropdown } from '@freddiesflowers/frontend-component-library';
import { addDays, formatDate } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import Modal from '@/components/structure/Modal';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ShiftDeliveryFrequencyModal',
    components: {
        Dropdown,
        Modal,
    },
    props: {
        shiftWeek: {
            type: Boolean,
            default: false,
        },
        shiftFrequency: {
            type: Boolean,
            default: false,
        },
        selectedSkippingDate: {
            type: Date,
            required: true,
        },
    },
    data() {
        return {
            success: null,
            selectedNextDelivery: null,
            schedulePlanChange: true,
        };
    },
    computed: {
        ...mapGetters({
            subscription: 'subscription/getActiveSubscription',
            deliveries: 'scheduledOrder/getDeliveries',
            plans: 'cms/getPlans',
            selectedDelivery: 'scheduledOrder/getSelectedDelivery',
        }),
        currentPlan() {
            return this.plans.find((item) => item.interval_count === this.subscription.plan_interval);
        },
        offeredPlan() {
            return this.plans.find((item) => item.interval_count === this.subscription.plan_interval + 1);
        },
        newDeliveryDate() {
            const deliveryDate = formatDate(addDays(new Date(this.selectedSkippingDate), 7), Dates.DASHED_YEAR_MONTH_DAY);
            const newDeliveryDate = this.deliveries.find((item) => item.datetime === deliveryDate);
            return newDeliveryDate.datetime;
        },
        allowedDeliveries() {
            return this.deliveries.filter((item) => !item.is_locked && !item.scheduled_order_id)
                .map((item) => {
                    item.human = formatDate(new Date(item.datetime), Dates.DAY_DATE_MONTH_YEAR);
                    return item;
                });
        },
        newDeliveryDateFormatted() {
            return formatDate(new Date(this.newDeliveryDate), Dates.DAY_DATE_MONTH_YEAR);
        },
        getFrequencyWithoutBraces() {
            return this.subscription.plan.replace(/ *\([^)]*\) */g, '');
        },
    },
    methods: {
        savePlan() {
            const date = this.shiftWeek ? this.newDeliveryDate : this.selectedNextDelivery.datetime;
            const plan = this.shiftWeek ? this.currentPlan : this.offeredPlan;

            subscriptionService.updateSubscriptionPlan(this.subscription.id, plan.slug, date, this.schedulePlanChange, '', this.selectedDelivery?.datetime).then((res) => {
                this.fetchData();
                const newPlanDetails = { plan: this.getFrequencyWithoutBraces, date: formatDate(new Date(date), Dates.DAY_DATE_MONTH_YEAR) };
                this.success = this.shiftWeek ? this.$t('SHIFT_DELIVERY_WEEK_SUCCESS', newPlanDetails) : this.$t('SHIFT_DELIVERY_PLAN_SUCCESS', newPlanDetails);
            }).catch(error => console.log(error.response.data));
        },
        fetchData() {
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        },
        showCustomerServiceMessage() {
            this.success = this.$t('SHIFT_DELIVERY_PLAN_CUSTOMER_SERVICE');
        },
        closeModal() {
            this.success = null;
            this.$emit('closed');
        },
    },
    mounted() {
        this.selectedNextDelivery = this.deliveries.find((item) => item.datetime === this.subscription.next_delivery_date);
    },
};
</script>

<style lang="scss" scoped>
.shift-delivery-modal {
    text-align: center;

    button {
        margin: 12px 8px 0px 8px;
    }
}

.divider {
    width: 25%;
    margin: 30px auto;
    border: 1px solid #1a1a1a;
}

.dropdown {
    width: 360px;
    margin: 0 auto;
    margin-bottom: 20px;
}
</style>
